import { createFileRoute } from '@tanstack/react-router'
import PartnersIndex from '@/pages/partners'

export const Route = createFileRoute('/_authenticated/partners/')({
  component: PartnersIndex,
})
